
import { Component, Vue } from 'vue-property-decorator'

export type ConvertAnswerFormatToTextType = { textarea: string }
export const CONVERT_ANSWER_FORMAT_TO_TEXT: ConvertAnswerFormatToTextType = {
  textarea: '記述式',
}

export type QuestionMarkerAssignmentSearchQuery = {
  gradeId?: number
  subjectId?: number
  studyContentName?: string
  problemSortNum?: number
  questionSortNum?: number
  answerFormat?: string
  scoringStatus?: string[]
}

export type QuestionMarkerAssignmentData = {
  id: number
  questionId: number
  studyContentId: number
  gradeName: string
  subjectName: string
  studyContentName: string
  problemSortNum: number
  questionSortNum: number
  answerFormat: string
  assignmentNumber: number
  scoredNumber: number
}

export type QuestionMarkerAssignmentDetailQuery = {
  id: number
}

export type QuestionMarkerAssignmentDetailData = {
  id: number
  gradeName: string
  subjectCode: string
  subjectName: string
  isKoHorizontal: boolean
  studyContentName: string
  problemSortNum: number
  questionSortNum: number
  answerFormat: string
  answerText: string
  allocation: number
  questionImagePaths: string[]
}

export type ScoringStatusType = {
  statusText: string
  statusValue: string
}

@Component
export default class QuestionMarkerAssignmentListApis extends Vue {
  /**
   * 採点状態一覧取得
   */
  protected async getScoringStatus(): Promise<ScoringStatusType[]> {
    return [
      { statusText: '採点中', statusValue: 'Scoring' },
      { statusText: '採点済', statusValue: 'Scored' },
      { statusText: '完了', statusValue: 'Completion' },
    ]
  }

  /**
   * マスタ取得
   */
  protected async loadMaster() {
    const { data: gradeData } = await Vue.prototype.$http.httpWithToken.get('/v1/grades')
    const { data: subjectData } = await Vue.prototype.$http.httpWithToken.get('/v1/subjects')
    return {
      grades: gradeData,
      subjects: subjectData,
    }
  }

  /**
   * 採点対象の試験一覧取得
   */
  protected async searchQuestionsMarkerAssignments(
    questionMarkerAssignmentSearchQuery: QuestionMarkerAssignmentSearchQuery
  ): Promise<QuestionMarkerAssignmentData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/marker/questions_marker_assignments', {
      params: questionMarkerAssignmentSearchQuery,
    })
    return data
  }

  /**
   * 採点対象の設問の詳細情報を取得
   */
  protected async getQuestionMarkerAssignment(
    questionMarkerAssignmentDetailQuery: QuestionMarkerAssignmentDetailQuery
  ): Promise<QuestionMarkerAssignmentDetailData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(
      `/v1/marker/questions_marker_assignments/${questionMarkerAssignmentDetailQuery.id}`
    )
    return data
  }
}
